import { render } from "./coupon.vue?vue&type=template&id=b8f91e18&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=b8f91e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f91e18"]])

export default __exports__